let tool = {
    localStorage: {
        set(key, val) {
            if (typeof val == 'object') {
                val = JSON.stringify(val)
            }
            window.localStorage.setItem(key, val)
        },
        get(key) {
            var reg = /^\{.*\}$/,
                reg1 = /^\[.*\]$/,
                val = window.localStorage.getItem(key)
            if (val) {
                if (reg.test(val) || reg1.test(val)) {
                    val = JSON.parse(val)
                }
                return val
            }
        },
        del(key) {
            window.localStorage.removeItem(key)
        }
    }, //localStorage本地存储
    sessionStorage: {
        set(key, val) {
            if (typeof val == 'object') {
                val = JSON.stringify(val)
            }
            window.sessionStorage.setItem(key, val)
        },
        get(key) {
            var reg = /^\{.*\}$/,
                reg1 = /^\[.*\]$/,
                val = window.sessionStorage.getItem(key)
            if (val) {
                if (reg.test(val) || reg1.test(val)) {
                    val = JSON.parse(val)
                }
                return val
            }
        },
        del(key) {
            window.sessionStorage.removeItem(key)
        }
    }, //sessionStorage本地存储
    formatDate(time, match, showDay) {
        //time默认为当前时间时间戳
        //match默认为yyyy-MM-dd HH:mm:ss
        //showDay是否显示星期
        if(time&&isNaN(time)){
            time = time.replace(/-/g, "/")
        }
        time = time ? new Date(time) : new Date();
        match = match ? match : 'yyyy-MM-dd HH:mm:ss';
        let year = time.getFullYear(),
            month = reset(time.getMonth() + 1),
            date = reset(time.getDate()),
            hours = reset(time.getHours()),
            seconds = reset(time.getSeconds()),
            minutes = reset(time.getMinutes()),
            day = time.getDay();
        function reset(n) {
            if (n < 10) {
                return '0' + n
            }
            return n
        }
        switch (day) {
            case 0: day = '星期日'
                break;
            case 1: day = '星期一'
                break;
            case 2: day = '星期二'
                break;
            case 3: day = '星期三'
                break;
            case 4: day = '星期四'
                break;
            case 5: day = '星期五'
                break;
            case 6: day = '星期六'
                break;
        }
        if (showDay) {
            return match = match.replace('yyyy', year).replace('MM', month).replace('dd', date + ' ' + day).replace('HH', hours).replace('mm', minutes).replace('ss', seconds)
          }
        return match = match.replace('yyyy', year).replace('MM', month).replace('dd', date).replace('HH', hours).replace('mm', minutes).replace('ss', seconds)
    },//格式化时间
    downFile(data, fileName, api, json) {
        let $vm = window.$vm;
        api = api || $vm.$api.downLogisticExcelTemp
        if (!json) {
            data = $vm.$qs.stringify(data)
        }
        $vm.$http(api, data).then(
            res => {
                if (res && res.data) {
                    let a = document.createElement("a"),
                        blob = new Blob([res.data]),
                        url = window.URL.createObjectURL(blob);
                    a.style.display = "none";
                    a.href = url;
                    a.download = fileName || 'Excel模板.xlsx';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
            }
        ).catch(() => {
            $vm.$message.error('导出失败')
        });
    },//导出表格Excel
    copy(value) {
        let ele = document.createElement('textarea')
        ele.setAttribute('readonly', 'readonly')
        ele.setAttribute('id', 'copy-inp')
        document.body.appendChild(ele)
        let node = document.getElementById('copy-inp')
        node.value = value
        node.select()
        document.execCommand('Copy')
        node.remove()
        window.$vm.$message('复制成功')
    },// 复制
    getQuery() {  
        var url = location.href; 
        var theRequest = new Object();  
        if (url.indexOf("?") != -1) {  
            var str = url.split("?")[1];  
            var strs = str.split("&");  
            for(var i = 0; i < strs.length; i ++) {  
              theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);  
            }  
        }  
        return theRequest;  
    }
}

export default tool